"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
var List_1 = __importDefault(require("../List"));
var MinusIcon_1 = __importDefault(require("./MinusIcon"));
var PrintMinus = function (props) {
    var children = Array.isArray(props.children) ? props.children : [props.children];
    return (react_1.default.createElement("div", { className: props.className },
        react_1.default.createElement(styles_1.LabelTitle, null, "\u041C\u0438\u043D\u0443\u0441\u044B"),
        react_1.default.createElement(List_1.default, { icon: react_1.default.createElement(MinusIcon_1.default, null) }, children),
        react_1.default.createElement(styles_1.Button, null,
            react_1.default.createElement("a", { href: props.btnHref, target: "_blank" }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438"))));
};
var SPrintMinus = (0, styled_components_1.default)(PrintMinus)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n\n    @media (min-width: 769px) {\n        ", " {\n            display: none;\n        }\n    }\n"], ["\n    ", "\n\n    @media (min-width: 769px) {\n        ", " {\n            display: none;\n        }\n    }\n"])), styles_1.PrintPlusMinus, styles_1.Button);
exports.default = SPrintMinus;
var templateObject_1;
